<template>
    <div ref="regenerateRecoveryCodesBlock" class="row">
        <div class="col-sm-12 mb-3" >
            <div class="d-flex flex-column gap-3 text-center align-items-center">
	            <i class="bi w-auto h-auto fs-large bi-shield-fill-minus"></i>
                <h3 class="fw-semi-bold m-0">{{ user && !user.has_recovery_codes ? 'Generate' : 'Regenerate' }} 2FA Recovery Codes</h3>
                <p class="text-secondary m-0">Are you sure you want to {{ user && !user.has_recovery_codes ? 'generate' : 'regenerate' }} new set of two factor authentication recovery codes. </p>
            </div>
        </div>

        <div class="col-12">

	        <div class="text-center mb-3" v-if="codeRegenerated">
		        <p class="text-secondary text-center mt-2">Here are your new recovery codes. Copy and Save them somewhere safe.</p>
		        <div class="row border shadow-sm rounded bg-light p-2">
			        <div class="row" v-html="recoveryCodesHTMLString"></div>
		        </div>
	        </div>
	        
            <div class="d-flex flex-row align-items-center justify-content-center gap-3 text-center ">
                <button class="btn btn-outline-secondary rounded-pill py-2 px-3" @click="close">Close</button>
	            <button v-if="codeRegenerated" class="btn btn-outline-dark rounded-pill py-6" @click="printRecoveryCode">Print Code</button>
	            <button v-if="codeRegenerated" class="btn btn-outline-dark rounded-pill py-6" @click="downloadRecoveryCode">Download Code</button>
	            <button v-if="codeRegenerated" class="btn btn-dark rounded-pill py-6" @click="copyRecoveryCode">Copy Code</button>
                <button v-if="!codeRegenerated" class="btn btn-dark rounded-pill py-2 px-3" @click="regenerateRecoveryCodes">
	                {{ user && !user.has_recovery_codes ? 'Generate Recovery Code' : 'Regenerate Code' }}</button>
            </div>
        </div>
    </div>

</template>

<script setup>
import { computed, watch, ref } from "vue";
import {useAppHelpers} from "@/composables/useAppHelpers.js";
import { useAuthStore } from "@/stores/auth-store.js";
import { useToast } from "@/composables/useToast.js";
import apiClient from "@/utils/axios.js";

const emits = defineEmits(['closeRegenerateRecoveryCodes']);

const auth = useAuthStore();
const helper = useAppHelpers();
const { displayToast } = useToast();

const regenerateRecoveryCodesBlock = ref(null);
const codeRegenerated = ref(false);

const recoveryCodes = ref([]);

const recoveryCodesHTMLString = computed(() => {
	return recoveryCodes.value.map(code => `<div class="col-6 recovery-code">${code}</div>`).join('<br>');
});

const recoveryCodesCopyString = computed(() => {
	return recoveryCodes.value.map(code => `${code}`).join("\n");
});

const copyRecoveryCode = () => {
	helper.copyText(recoveryCodesCopyString.value);
	displayToast('Recovery codes copied to clipboard.', 'outline-success', 5000);
}

const printRecoveryCode = () => {
	const printWindow = window.open('', '', 'width=800,height=600');
	printWindow.document.write('<html lang="en"><head><title>Print Recovery Codes</title></head><body>');
	printWindow.document.write('<h3>My Meds - Two Factor Authentication Recovery Codes</h3>');
	printWindow.document.write('<p>Use these recovery codes if you don\'t have access to the Two Factor Authentication Source.</p>');
	printWindow.document.write('<pre>' + recoveryCodesCopyString.value + '</pre>');
	printWindow.document.write('</body></html>');
	printWindow.document.close();
	printWindow.print();
}

const downloadRecoveryCode = () => {
	const blob = new Blob([recoveryCodesCopyString.value], { type: 'text/plain' });
	const link = document.createElement('a');
	link.href = URL.createObjectURL(blob);
	link.download = 'my_meds_recovery_codes.txt';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	displayToast('Recovery codes downloaded successfully.', 'outline-success', 5000);
}

const user = ref(auth.user);
watch(() => auth.user, (newVal) => {
	user.value = newVal;
});

const regenerateRecoveryCodes = async () => {
	try{
		helper.loaderOn(regenerateRecoveryCodesBlock.value);
		const response = await apiClient.post('/auth/user/regenerateRecoveryCodes', {
		});

		if(response.status >= 200 && response.status < 300){
			codeRegenerated.value = true;
			recoveryCodes.value = response.data.recovery_codes;
		}
		helper.loaderOff(regenerateRecoveryCodesBlock.value);
	}
	catch (error) {
		codeRegenerated.value = false;
		helper.loaderOff(regenerateRecoveryCodesBlock.value);
	}
}

const close = async () => {
	emits('closeRegenerateRecoveryCodes');
}

defineExpose({
    close
});
</script>
